var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackOverflowDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "85px",
    viewBox: "0 0 75 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stack-overflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3.08347436%",
    y1: "61.6222938%",
    x2: "112.70225%",
    y2: "37.4753312%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC500",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2222",
    offset: "32.9878827%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720096",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Docs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Docs_LandingPage_Design_DarkMode",
    transform: "translate(-346.000000, -2476.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(47.000000, 2407.452708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(283.500000, 69.300000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stack-overflow",
    transform: "translate(15.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,52.4309023 L0,81.1476091 C0,82.6899958 1.2517921,83.9417879 2.79417879,83.9417879 L71.7172557,83.9417879 C73.2596424,83.9417879 74.5114345,82.6899958 74.5114345,81.1476091 L74.5114345,52.4309023 C74.5114345,48.7351351 68.9230769,48.7314096 68.9230769,52.4309023 L68.9230769,78.3534304 L5.58835759,78.3534304 L5.58835759,52.4309023 C5.58835759,48.7351351 0,48.7351351 0,52.4309023 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3052807,69.5834345 L53.5811726,69.5834345 C57.2769397,69.5834345 57.2806653,63.9950769 53.5811726,63.9950769 L17.3052807,63.9950769 C13.6095135,63.9950769 13.6057879,69.5834345 17.3052807,69.5834345 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2903784,52.3452141 C55.1161081,60.0906778 52.8248815,59.6957672 53.3762661,59.6957672 C56.718104,59.6957672 57.213605,54.8376216 53.9351019,54.1632931 L18.415501,46.8686237 C14.7942453,46.1272349 13.6653971,51.6000998 17.2903784,52.3452141 L17.2903784,52.3452141 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8094969,32.9983202 C55.7904366,49.8528067 54.1921663,49.4690728 55.4365073,49.4690728 C58.3797089,49.4690728 59.3111019,45.4864366 56.6845738,44.1750353 L24.3056299,27.9986029 C21.008499,26.3444491 18.5011892,31.3441663 21.8094969,32.9983202 L21.8094969,32.9983202 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.072815,18.446237 L58.4467692,40.2818129 C61.3303617,42.5059792 64.824948,38.1396091 61.8556674,35.8558337 L33.4817131,14.0202578 C30.5534137,11.7588358 27.14079,16.1922661 30.072815,18.446237 L30.072815,18.446237 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6570146,29.2094137 L48.3392931,1.21919335 C46.1039501,-1.72028274 41.6518919,1.66253638 43.8946861,4.60573805 L65.2124075,32.5959584 C67.4328482,35.5168067 71.914711,32.1749688 69.6570146,29.2094137 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackOverflowDarkMode);
export default __webpack_public_path__ + "static/media/stack-overflow-dark-mode.5ae317f0e8452cf5d10547535114c47a.svg";
export { ForwardRef as ReactComponent };